module.exports = __webpack_public_path__ + "static/media/bellImage.c5995c42.svg";